
import { defineComponent, computed, ref } from 'vue'
import { useFreeFormsModule } from '@/modules/free-forms'
import { useFormModule } from '@/modules/_shared/forms'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import FreeFormsCreateNewTranslationDomainDialog from '@/components/free-forms/dialogs/create-new-translation-domain.vue'
import FreeFormsTranslationDomainTranslationsList from '@/components/free-forms/translation-domain-translations-list.vue'
import useTranslationHelper from '@/components/free-forms/translation-domain-helper'

export default defineComponent({
    name: 'free-forms-form-field-description-translation-select',
    components: { FreeFormsTranslationDomainTranslationsList },
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String
        },
        label: {
            type: String,
            default: 'Description translation'
        }
    },
    async setup (props, { emit }) {
        const $q = useQuasar()
        const { getTranslationDomainTranslations, translationDomainTranslations } = useFreeFormsModule()
        const { getDescriptionTranslations, translationOptions } = useTranslationHelper()

        await getDescriptionTranslations()

        const localModel = computed({
            get: () => props.modelValue,
            set: value => emit('update:modelValue', value)
        })

        const lastValue = ref('')

        const onNewDomainCreated = (newValue: string) => {
            localModel.value = newValue
            lastValue.value = newValue
            getTranslationDomainTranslations(newValue)
        }

        function onUpdate (value: string) {
            if (value === 'create_new_domain') {
                $q.dialog({
                    component: FreeFormsCreateNewTranslationDomainDialog,
                    componentProps: {
                        updateCallback: onNewDomainCreated
                    }
                }).onCancel(() => {
                    localModel.value = lastValue.value
                })
            } else {
                getTranslationDomainTranslations(value)
                lastValue.value = value
            }
            emit('update:modelValue', value)
        }

        const {
            validations: {
                requiredRule
            }
        } = useFormModule()

        return {
            translationOptions,
            requiredRule,
            onUpdate,
            translationDomainTranslations,
            localModel
        }
    }
})
